import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';
import ApplyRounding from '../../../../../../../../../utils/math/ApplyRounding';

export function priceFiltersTargetsBuilder({parsedStatusObj}) {
  const { currentPrice, targets } = parsedStatusObj;
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        All price targets filtered out by current price. Current price:{' '}
        {currentPrice
          ? '$' + ApplyRounding(Number(currentPrice), 2)
          : 'unknown'}
        . Price targets: [
        {targets
          ? targets.map((target) => '$' + ApplyRounding(Number(target), 2))
          : ''}
        ]
      </Body3>
    </td>
  );
}
